module.exports = __webpack_public_path__ + "media/roomBgm.532bb3ba.mp3";